var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabletMostPopularPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 438,
  viewBox: "0 0 704 438",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.500977,
  width: 703,
  height: 437,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 664,
  height: 243,
  transform: "translate(20 20.001)",
  fill: "white"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.001,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63.001,
  width: 107.2,
  height: 200,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 159.199,
  y: 63.001,
  width: 107.2,
  height: 200,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 298.4,
  y: 63.001,
  width: 107.2,
  height: 200,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 437.6,
  y: 63.001,
  width: 107.2,
  height: 200,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 576.801,
  y: 63.001,
  width: 107.2,
  height: 200,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 684,
  y1: 295.501,
  x2: 20,
  y2: 295.501,
  stroke: "#110000"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 311.001,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 350.001,
  width: 664,
  height: 28,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 390.001,
  width: 664,
  height: 28,
  fill: "#E5E5E5"
})));
export default SvgTabletMostPopularPlaceholder;